import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    categorySelected: {},
    wizard: {
      people: 1,
      date: null,
      hour: null,
      name: '',
      email: '',
      phone: '',
      observations: '',
      type: 'standard'
    },
    avaliableDates: [],
    exceptions:[]
  },
  getters: {
      getCategorySelected(state){
          return state.categorySelected;
      },
      getPeople(state){
        return state.wizard.people
      },
      getDate(state){
        return state.wizard.date;
      },
      getHour(state){
        return state.wizard.hour;
      },
      getName(state){
        return state.wizard.name;
      },
      getPhone(state){
        return state.wizard.phone;
      },
      getEmail(state){
        return state.wizard.email;
      },
      getObservations(state){
        return state.wizard.observations;
      },
      getWizard(state){
        return state.wizard;
      },
      getTypeTable(state){
        return state.wizard.type;
      },
      getAvaliableDates(state){
        return state.avaliableDates;
      },
      getExceptions(state){
        return state.exceptions;
      },
      getValidButton(state){
        return state.wizard.people && state.wizard.date && state.wizard.hour;
      }
  },
  mutations: {
    selectCategory (state, category) {
      state.categorySelected = {...category}
    },
    setTypeTable(state, payload){
      state.wizard.type = payload;
    },
    toggleTypeTable(state){
      state.wizard.type = state.wizard.type == 'vip' ? 'standard' : 'vip';
    },
    setPeople(state, payload){
      state.wizard.date = null;
      state.wizard.hour = null;
      state.wizard.people = payload;
    },
    setDate(state, payload){
      state.wizard.hour = null;
      state.wizard = {
        ...state.wizard,
        date: payload
      }
    },
    setHour(state, payload){
      state.wizard = {
        ...state.wizard,
        hour: {...payload}
      }
    },
    setName(state, payload){
      state.wizard = {
        ...state.wizard,
        name: payload
      }
    },
    setPhone(state, payload){
      state.wizard = {
        ...state.wizard,
        phone: payload
      }
    },
    setEmail(state, payload){
      state.wizard = {
        ...state.wizard,
        email: payload
      }
    },
    setObservations(state, payload){
      state.wizard = {
        ...state.wizard,
        observations: payload
      }
    },
    setAvaliableTables(state, payload){
      state.avaliableDates = [...payload]
    },
    setExceptions(state, payload){
      state.exceptions = [...payload]
    }
  }
})

export default store;
